// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
export const xSwiperStyle = css`
    width: 100%;
    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }

    // override .swiper-pagination-bullets styles
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: initial;
        top: initial;
        left: initial;
        width: initial;
    }

    &&& .swiper-lazy-preloader {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${color("common.black", 0.33)};
        border: 0;
        animation: unset;
        border: unset;
        border-radius: 2px;
        margin: 0;
        // for now lazy loaded it but don't show loader
        display: none;
        &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            display: block;
            transform: translate(-50%, -50%);
            animation: swiper-preloader-spin 1s infinite linear;
            width: 40px;
            height: 40px;
            z-index: 10;
            border-radius: 50%;
            border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
            border-top-color: transparent;
        }
    }
`;
